import isNullish from '@bitty/nullish';
import None from './None.js';
import Some from './Some.js';
export default function fromNullish(value) {
    return isNullish(value) ? None : Some(value);
}
//# sourceMappingURL=fromNullish.js.map